var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notifications.data)?_c('div',[_c('NotificationsList',{attrs:{"notifications":_vm.notificationsList || []}}),_vm._v(" "),_c('Sentinel',{attrs:{"disabled":_vm.endReached},on:{"intersecting":_vm.getNext}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }